export default __webpack_public_path__ + "static/media/frame_zh_cn_sp-landscape.5b8d1cbe.png";